import {
  BadgeCheckIcon,
  BanIcon,
  BellRingIcon,
  CircleCheckBigIcon,
  FileCheck2Icon,
  FlagIcon,
  type LucideIcon,
  MessageSquareIcon,
  RefreshCwIcon,
  SendIcon,
  UsersIcon,
  XCircleIcon,
} from 'lucide-react'

import type { NotificationType } from '../types'

/** Icon and accent colour per notification type. Add an entry when a type is added. */
const styles: Record<NotificationType, { icon: LucideIcon; className: string }> = {
  MASTER_SHARED: { icon: SendIcon, className: 'bg-orange-soft text-orange-ink' },
  TEMPLATE_CHOSEN: { icon: CircleCheckBigIcon, className: 'bg-sky-soft text-info-ink' },
  REVIEW_ASSIGNED: { icon: UsersIcon, className: 'bg-orange-soft text-orange-ink' },
  REVIEW_SHARED: { icon: UsersIcon, className: 'bg-teal-soft text-teal-ink' },
  COMMENT_RECEIVED: { icon: MessageSquareIcon, className: 'bg-sky-soft text-info-ink' },
  REVISION_REQUESTED: { icon: RefreshCwIcon, className: 'bg-sky-soft text-info-ink' },
  PROJECT_APPROVED: { icon: CircleCheckBigIcon, className: 'bg-teal-soft text-teal-ink' },
  PROJECT_COMPLETED: { icon: FlagIcon, className: 'bg-teal-soft text-teal-ink' },
  PROJECT_CANCELLED: { icon: BanIcon, className: 'bg-bg-tertiary text-text-secondary' },
  VARIATION_SHARED: { icon: BellRingIcon, className: 'bg-orange-soft text-orange-ink' },
  VARIATION_APPROVED: { icon: BadgeCheckIcon, className: 'bg-teal-soft text-teal-ink' },
  VARIATION_REJECTED: { icon: XCircleIcon, className: 'bg-bg-tertiary text-destructive' },
}

export const notificationStyle = (type: NotificationType) =>
  styles[type] ?? { icon: FileCheck2Icon, className: 'bg-bg-tertiary text-text-secondary' }
